export const LabelData = [
    {
        labelY: -103,
        image: "financement",
        zoneId: 2
    },
    {
        labelY: -34,
        image: "exploitation",
        zoneId: 0
    },
    {
        labelY: 37,
        image: "investissement",
        zoneId: 1
    },

]